import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { useSelector } from 'react-redux';
import HttpsRedirect from 'react-https-redirect';
import FullScreenLoader from './components/FullScreenLoader';
import AppRouter from './routes/AppRouter';

const GlobalFullScreenLoader = () => {
	const isFullScreenLoading = useSelector(state => state.fullScreenLoader.isFullScreenLoading);
	return isFullScreenLoading ? <FullScreenLoader /> : null;
};

const App = () => {
	return (
		<>
			<GlobalFullScreenLoader />
			<RouterProvider router={AppRouter} />
		</>
	);
};

export default App;
